import { graphql, navigate, useStaticQuery } from 'gatsby';
import { and } from 'ramda';
import React, { FC, useEffect } from 'react';

import useMemberInfo, { B2BMember, B2BMemberKind } from '@hooks/useMemberInfo';

import { keysToCamel } from '@utils/butter';
import { exists } from '@utils/general';

import { IPageProps } from '@folx-types/flow-steps';

import { b2bMember, b2bMemberName } from '@graphql/fragments/b2bMember';

import DependentInvite, { IDependentInvitePageContent } from './DependentInvite.component';

interface IDependentInvitePageProps extends IPageProps {}

const DependentInvitePage: FC<IDependentInvitePageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "dependent-invite" }) {
				page_header
				page_info
				email_label
				email_placeholder
				over_eighteen_label
				invite_label
				dependent_invite_error
			}
		}
	`);

	const refinedContent: IDependentInvitePageContent = keysToCamel(
		pageContent
	) as IDependentInvitePageContent;

	const { memberInfo } = useMemberInfo<B2BMember>([{ name: b2bMemberName, node: b2bMember }]);

	useEffect(() => {
		if (
			exists(memberInfo) &&
			(!exists(memberInfo?.b2b?.customer) || memberInfo?.b2b?.kind !== B2BMemberKind.primary)
		) {
			navigate('/app/member');
		}
	});

	return <DependentInvite pageContent={refinedContent} path={path} />;
};

export default DependentInvitePage;
